var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-wrapper"},[_c('transition',{attrs:{"mode":"out-in"}},[(_vm.loading)?_c('span',[_vm._v("Loading...")]):_c('div',{staticClass:"loaded-content"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }